<script>
  import { Router } from '@sveltech/routify';
  import { onDestroy, onMount } from 'svelte';

  import { routes } from '../.routify/routes';
  import { websocket } from './stores';

  import { SvelteToast } from '@zerodevx/svelte-toast';

  const reconnect = () => websocket.connectWebsocket();
  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      reconnect();
    }
  };

  onMount(() => {
    reconnect();
    window.addEventListener('online', reconnect);
    document.addEventListener('visibilitychange', handleVisibilityChange);
  });

  onDestroy(() => {
    window.removeEventListener('online', reconnect);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  });
</script>

<Router {routes} />
<SvelteToast />

<style global lang="scss">
  @use '../static/global' as *;
  @use '../static/styles/index' as *;
</style>
